import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import httpClient from '../../helpers/httpClient'
import LoadingSpinner from '../../placeholders/LoadingSpinner'
import Label from '../../Label'
import { formatDate } from '../../helpers/formatDate'
import { rentalContractTypeLabelColors } from '../../../assets/data/data'
import './RentalSection.css'

function RentalSection({ unit }) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [contracts, setContracts] = useState([])

  useEffect(() => {
    const fetchContracts = async () => {
      if (!unit || !unit.id) return
      setIsLoading(true)
      try {
        const query = new URLSearchParams({
          page: '1',
          limit: '100',
          detailed: 'true',
          unit_id: String(unit.id),
        }).toString()
        const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/rental-contracts?${query}`)
        setContracts(response.data.rental_contracts || [])
      } finally {
        setIsLoading(false)
      }
    }

    fetchContracts()
  }, [unit?.id])

  const handleOnClickRow = (contractId) => {
    navigate(`/rental-contracts/${contractId}`)
  }

  return (
    <div className="popout_body__content_container" id="unit-rental-section">
      <h2>Rental Contracts</h2>
      <div className='table'>
        <div className='table__header-5'>
          <div className='table__header--field'>Contract number</div>
          <div className='table__header--field'>Contract start date</div>
          <div className='table__header--field'>Tenant(s)</div>
          <div className='table__header--field'>Contract type</div>
          <div className='table__header--field'>Type</div>
        </div>
        <div className='table__rows_container'>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            contracts.map((c, index) => {
              const tenantNames = Array.isArray(c.participants)
                ? c.participants
                    .filter(p => (p.participant_type || '').toLowerCase() === 'tenant')
                    .map(p => {
                      if (p.contact) {
                        const first = p.contact.first_name || ''
                        const last = p.contact.last_name || ''
                        return `${first} ${last}`.trim()
                      }
                      if (p.company) {
                        return p.company.company_name || null
                      }
                      return null
                    })
                    .filter(Boolean)
                : []

              return (
                <div
                  className={`table__row-5 ${c.active === false ? 'inactive' : ''}`}
                  key={index}
                  onClick={() => handleOnClickRow(c.id)}
                  data-contract-id={c.id}
                >
                  <div className='table__row--field rental-contract-id-cell'>
                    <span>{c.id || 'N/A'}</span>
                    {c.active === false ? <span className='rental-contract-status'>Inactive</span> : null}
                  </div>
                  <div className='table__row--field'>{c.start_date ? formatDate(c.start_date) : 'N/A'}</div>
                  <div className='table__row--field'>
                    {tenantNames.length > 0 && (
                      <div className='labels-container'>
                        {tenantNames.map((name, i) => (
                          <span key={i} className='label-item'>{name}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='table__row--field'>
                    {c.contract_type || 'N/A'}
                  </div>
                  <div className='table__row--field'>
                    {c.rental_type ? (
                      <Label
                        title={c.rental_type}
                        labelColor={rentalContractTypeLabelColors[c.rental_type] || 'gray'}
                      />
                    ) : null}
                  </div>
                </div>
              )
            })
          )}
          {!isLoading && contracts.length === 0 && (
            <div className='table__row-1'>
              <div className='table__row--field'>No rental contracts linked to this unit.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RentalSection
